/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useCallback } from "react";
import IntlTelInputBox from "../login/IntlTelInputBoxWithEmail";
import OTPInput from "react-otp-input";
import axios from "axios";
import { useAuth } from "../../context/auth";
import { addCartDataAfterLogin } from "../../Helper";
import { useLocation, useNavigate } from "react-router-dom";
import { getDisplayName } from "react-bootstrap-typeahead/types/utils";
import { toast } from "react-toastify";

function NewLoginRegister({ show, setShowLoginPopup, redirect, locationPath }) {
  const navigate = useNavigate();
  const [fullPhone, setFullPhone] = useState("");
  const [intelValid, setIntelValid] = useState(false);
  const [loading, setLoading] = useState(false);
  const [otp, setOTP] = useState(false);
  const [otpInput, setOTPInput] = useState("");
  const [otpGenerate, setOTPGenerate] = useState("");
  const [resendTimer, setResendTimer] = useState(30);
  const [canResend, setCanResend] = useState(false);
  const [otpError, setOtpError] = useState("");
  const [auth, setAuth] = useAuth();
  const [userLogin, setUserLogin] = useState(false);
  const [userRegister, setUserRegister] = useState(false);
  const [otpVerified, setOtpVerified] = useState(false);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [errors, setErrors] = useState({});
  const [registerSubmit, setRegisterSubmit] = useState(false);
  const [editNumber, setEditNumber] = useState(false);
  const [inputType, setInputType] = useState("blank");
  const [number, setNumber] = useState("");
  const location = useLocation();

  const startResendTimer = useCallback(() => {
    setCanResend(false);
    setResendTimer(30);
    const timer = setInterval(() => {
      setResendTimer((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          setCanResend(true);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  }, []);
  const checkInputType = (value) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const mobileRegex = /^[6-9]\d{9}$/;

    if (emailRegex.test(value)) {
      return "email";
    } else if (mobileRegex.test(value)) {
      return "phone";
    } else {
      return "";
    }
  };

  const sendOTP = useCallback(async () => {
    try {
      setLoading(true);

      const inputTypecheck = checkInputType(fullPhone);
      var fieldName = "phone";
      if (inputTypecheck && inputTypecheck === "email") {
        fieldName = "email";
      } else if (inputTypecheck && inputTypecheck === "phone") {
        fieldName = "phone";
      }
      const sessionCountryData = JSON.parse(
        sessionStorage.getItem("country_data")
      );
      //console.log('sessionCountryData', sessionCountryData)
      const { data } = await axios.post(
        `${process.env.REACT_APP_API_URL}/auth/sendOTPChekout`,
        {
          [fieldName]: fullPhone,
          sessionCountryData: sessionCountryData
        }
      );
      if (data?.status) {
        if (fieldName && fieldName === "phone") {
          setUserLogin(data?.login === true);
          setUserRegister(data?.register === true);
          setOTPGenerate(data?.otp);
          setOTP(true);
          startResendTimer();
        }
        if (fieldName && fieldName === "email" && data?.register === true) {
          setEmail(fullPhone);
          setUserLogin(data?.login === true);
          setUserRegister(data?.register === true);
          setInputType("phone");
          setNumber("");
          setEditNumber("");
        }

        if (fieldName && fieldName === "email" && data?.login === true) {
          setEmail(fullPhone);
          setUserLogin(data?.login === true);
          setUserRegister(data?.register === true);
          setInputType("email");
          setOTPGenerate(data?.otp);
          setOTP(true);
          startResendTimer();
        }
      } else {
        setOtpError("Failed to send OTP. Please try again.");
      }
    } catch (error) {
      setOtpError("Error sending OTP.");
    } finally {
      setLoading(false);
    }
  }, [fullPhone, startResendTimer]);

  const verifyOTP = useCallback(
    async (redirect) => {
      if (userLogin) {
        try {
          const payload = {
            otp: otpInput,
            [inputType]: fullPhone,
          };

          const { data } = await axios.post(
            `${process.env.REACT_APP_API_URL}/auth/login`,
            payload
          );

          if (data?.status) {
            setAuth({
              user: data.results,
              token: data.token,
            });
            localStorage.setItem(
              "auth",
              JSON.stringify({
                user: data.results,
                token: data.token,
              })
            );
            addCartDataAfterLogin();
            if (redirect) {
              const from =
                locationPath === "checkoutPage"
                  ? "/checkout"
                  : location?.state || "/";

              navigate(from, { replace: true });
            } else {
              setShowLoginPopup(false);
            }
            toast.success("Login Successful!", {
              style: {
                background: "#ebfbee",
                color: "#1c6931"
              },
            });
          } else {
            console.log("error");
            setOtpError("Incorrect OTP. Please try again.");
          }
        } catch (error) {
          setOtpError("Error verifying OTP.");
        }
      } else {
        if (userRegister) {
          setOtpError(
            Number(otpInput) !== otpGenerate
              ? "Incorrect OTP. Please try again."
              : ""
          );
          setOtpVerified(Number(otpInput) === otpGenerate);
        }
      }
    },
    [otpInput, fullPhone, setAuth, navigate, userLogin, userRegister]
  );

  useEffect(() => {
    if (intelValid) {
      sendOTP();
    }
  }, [intelValid]);

  useEffect(() => {
    if (otpInput.length === 6) verifyOTP(redirect);
  }, [otpInput]);

  useEffect(() => {
    const isAuth = JSON.parse(localStorage.getItem("auth"));
    if (isAuth && isAuth.token) {
      setAuth(isAuth);
    }
  }, []);

  const handleEditNumber = () => {
    setOTP(false);

    if (inputType === "phone") {
      setInputType("phone");
      setEditNumber(fullPhone);
    } else {
      setInputType("email");
      setNumber(fullPhone);
    }

    //setIntelValid(true);
  };

  const validateForm = () => {
    let formErrors = {};
    let isValid = true;

    if (!firstName.trim()) {
      formErrors.firstName = "Please enter your first name.";
      isValid = false;
    }
    if (!lastName.trim()) {
      formErrors.lastName = "Please enter your last name.";
      isValid = false;
    }
    if (!email.trim()) {
      formErrors.email = "Please enter a valid email.";
      isValid = false;
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      formErrors.email = "Invalid email format.";
      isValid = false;
    }

    setErrors(formErrors);
    return isValid;
  };

  const handleRegistration = async (event) => {
    event.preventDefault();
    setRegisterSubmit(true);
    if (!validateForm()) {
      setRegisterSubmit(false);
      return;
    }

    try {
      const { data } = await axios.post(
        `${process.env.REACT_APP_API_URL}/auth/checkEmailChekout`,
        { email: email }
      );

      if (data.emailExist) {
        setRegisterSubmit(false);
        setErrors((prevErrors) => ({
          ...prevErrors,
          email: "Email already exists. Please use a different one.",
        }));
        return;
      }

      // Proceed with full form submission
      //console.log({ firstName, lastName, email, fullPhone });
      const password = firstName + "@123";

      const { data: response } = await axios.post(
        `${process.env.REACT_APP_API_URL}/auth/register`,
        {
          first_name: firstName,
          last_name: lastName,
          email: email,
          phone: fullPhone,
          password: password,
          c_code: "+00",
        }
      );

      if (response?.status) {
        setAuth({
          user: response.results,
          token: response.token,
        });
        localStorage.setItem(
          "auth",
          JSON.stringify({
            user: response.results,
            token: response.token,
          })
        );
        addCartDataAfterLogin();
        setRegisterSubmit(false);
        if (redirect) {
          const from =
            locationPath === "checkoutPage"
              ? "/checkout"
              : location?.state || "/";

          navigate(from, { replace: true });
        } else {
          setShowLoginPopup(false);
        }
        toast.success("Login Successful!", {
          style: {
            background: "black",
            color: "white",
          },
        });
      } else {
        alert("Failed to submit the form. Please try again.");
      }
    } catch (error) {
      console.error("Error checking email or submitting form:", error);
      setErrors((prevErrors) => ({
        ...prevErrors,
        email: "An error occurred. Please try again later.",
      }));
    }
  };
  //console.log(intelValid, editNumber);
  return (
    <>
      {show && !otp && (
        <div className="login-register-wrap">
          <h3>Please Sign up or Login to checkout</h3>
          <div className="login-register-box">
            <IntlTelInputBox
              setFullPhone={setFullPhone}
              handleIntel={setIntelValid}
              selectedPhone={editNumber ? editNumber : ""}
              setInputType={setInputType}
              inputType={inputType}
              setEditNumber={setEditNumber}
              setNumber={setNumber}
              number={number}
            />
            <div className="button-field">
              <button disabled={!editNumber || loading} onClick={sendOTP}>
                {loading ? (
                  <span className="custom-items-center">
                    <span
                      className="spinner-grow custom-spinner spinner-grow-sm mx-1"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    <span
                      className="spinner-grow custom-spinner spinner-grow-sm mx-1"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    <span
                      className="spinner-grow custom-spinner spinner-grow-sm mx-1"
                      role="status"
                      aria-hidden="true"
                    ></span>
                  </span>
                ) : (
                  "Next"
                )}
              </button>
            </div>
          </div>
        </div>
      )}
      {otp && !otpVerified && (
        <div className="login-register-wrap">
          <h3 className="otp-num-edit">
            Enter the OTP sent on your{" "}
            {inputType === "phone" ? "WhatsApp/Email" : "Email/WhatsApp"}{" "}
            <span style={{ display: "inline-block" }}>
              {" "}
              <span style={{ textDecoration: "underline" }}>{fullPhone}</span>
              <span className="ph-edit" onClick={handleEditNumber}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className="size-6"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L6.832 19.82a4.5 4.5 0 0 1-1.897 1.13l-2.685.8.8-2.685a4.5 4.5 0 0 1 1.13-1.897L16.863 4.487Zm0 0L19.5 7.125"
                  />
                </svg>{" "}
                edit
              </span>
            </span>
          </h3>
          <div className="otp-field new-otp-field">
            <OTPInput
              shouldAutoFocus
              skipDefaultStyles
              inputStyle="otp-input"
              value={otpInput}
              onChange={setOTPInput}
              numInputs={6}
              renderInput={(props) => <input {...props} />}
            />
          </div>
          {otpError && (
            <p className="error-message" style={{ color: "red" }}>
              {otpError}
            </p>
          )}
          <div className="resend-otp">
            <button type="button" disabled={!canResend} onClick={sendOTP}>
              {canResend
                ? "Resend OTP"
                : `Resend OTP in ${resendTimer} seconds`}
            </button>
          </div>
        </div>
      )}

      {otpVerified && userRegister && (
        <div className="login-register-wrap form-box">
          <form className={`row needs-validation noValidate`}>
            <div className="col-6 login-data mobile-field">
              <input
                type="text"
                placeholder="First Name"
                className={`form-control input-text register-form-control ${errors.firstName ? "is-invalid" : ""
                  }`}
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
              />
              {errors.firstName && (
                <div className="invalid-feedback">{errors.firstName}</div>
              )}
            </div>
            <div className="col-6 login-data mobile-field">
              <input
                type="text"
                placeholder="Last Name"
                className={`form-control input-text register-form-control ${errors.lastName ? "is-invalid" : ""
                  }`}
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
              />
              {errors.lastName && (
                <div className="invalid-feedback">{errors.lastName}</div>
              )}
            </div>
            <div className="col-md-12 login-data mobile-field">
              <input
                type="email"
                placeholder="Email"
                className={`form-control input-text register-form-control ${errors.email ? "is-invalid" : ""
                  }`}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              {errors.email && (
                <div className="invalid-feedback">{errors.email}</div>
              )}
            </div>
            <div className="col-md-12 login-data mobile-field form-submit-btn">
              <input
                type="button"
                className="form-control input-text register-form-control"
                value={registerSubmit ? "Processing..." : "Submit"}
                onClick={handleRegistration}
                disabled={registerSubmit}
              />
            </div>
          </form>
        </div>
      )}
    </>
  );
}

export default NewLoginRegister;
